<template>
  <div>
    <gmxkzTx />
  </div>
</template>

<script>
// 获取接口地址
import gmxkzTx from '@/components/tztx/gmxkzTx'

export default {
  name: 'Gmxkzwsytx',
  components: {
    gmxkzTx
    // sideMenu,
    // Header
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
